import styled from "@emotion/styled";
import colors from "../../../common/styles/colors";

export const EventSelectWrapper = styled.div`
  background-color: ${colors.darkGrey2};
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media all and (max-width: 950px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    img {
      width: 20%;
    }
  }
`;

export const EventSelectionHeaderWrapper = styled.div`
  max-width: 620px;
  min-width: 360px;

  @media all and (max-width: 900px) {
    display: none;
  }
`;

export const EventSelectionDropdownWrapper = styled.div`
  .select-box-dropdown {
    margin-top: 5px;
    position: relative;
    display: flex;
    z-index: 2;
    & .MuiList-root {
      position: absolute;
    }
  }
    
    & .MuiButton-root.Mui-focusVisible {
        outline: auto ${colors.primary}
    }
  
    & .event-edition-dropdown, .event-edition-dropdown-placeholder {
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border: solid 1px ${colors.lightGrey4};
    width: 100%;
    border-radius: 5px;
    font-size: 14px;
    padding: 8px 10px;
    margin-bottom: 8px;
    
    .dropdown-icon {
      color: ${colors.primary};
    }
  }

  & .event-edition-dropdown {
    color: black;
  }
  
  & .event-edition-dropdown-placeholder {
    color: ${colors.lightGrey5};
  }
  
  & .event-edition-list {
     z-index: 99;
     position: absolute;
     display: flex;
     align-items: center;
     flex-direction: column;
     border: solid 1px ${colors.lightGrey4};
     border-top-color: transparent;
     border-radius: 5px;
     padding-top: 0;
     top: 43px;
     background-color: white;
     font-size: 14px;
     height: 230px;

     width: 99.4%;
     @media (max-width:768px) {
       width: 99.7%;
       height: 280px;
     }
    
    .list-container {
      width: 90%;
      margin-top: 58px;
      padding: 0;
      overflow-x: hidden;
      overflow-y: scroll;
      max-height: 170px;

      ::-webkit-scrollbar {
          padding-top: 2em;
        width: 8px;
      }

      ::-webkit-scrollbar-track {
        background: #ffffff;
      }
      
      ::-webkit-scrollbar-thumb {
        background: ${colors.grey['100']};
        border-radius: 5px;
      }
      
      .list-item {
          //top: -10px;
        padding: 8px 0;
        font-size: 16px;
        cursor: pointer;
        color: ${colors.primary};
        max-height: 38px;
        
        &:hover {
          background-color: ${colors.lightGrey1};
        }
      }
    }

    .searcher-container {
      position: sticky;
      background-color: white;
      width: 100%;
      z-index: 99;
      top: 0;
      padding-top: 12px;
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      align-items: center;
      & .MuiFormControl-root {
        display: flex
      }

      .search-icon {
        position: absolute;
        font-size: 17px;
        right: 7%;
        color: ${colors.primary};

        @media (max-width: 768px) {
          right: 10%;
        }
      }
      
      .searcher {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;

        & .MuiOutlinedInput-root {
          min-width: 92%;
          border-radius: 4px!important;
          font-size: 14px;

          & .MuiOutlinedInput-input {
            border-radius: 4px!important;
            padding: 8px 12px;
          }

          & .MuiOutlinedInput-notchedOutline {
            padding: 0;
          }
        }
      }
    }
  }

  .MuiFormHelperText-root {
    position: absolute;
    top: -34px;
    left: -12px;
  }
`;

export const SettingsSelectBoxWrapper = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 48px 58px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 475px;
  box-sizing: border-box;

  @media all and (max-width: 950px) {
    width: 90vw;
    padding: 48px 40px;
  }

  & > span {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin: 0 0 18px 0;
  }
  
  .subtitle {
    padding: 0;
    margin: 0;
    margin-top: 7px;
    font-size: 14px;
    font-weight: 600;
  }
  
  .select-box, .select-box-dropdown {
    margin-top: 12px;
  }
  
  .select-box > span {
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  & .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
  }

  & > Button {
    margin-top: 18px;
    padding: 8px;
  }
    
    & .confirm-button:focus-visible {
      outline: auto;
      outline-width: medium;
      outline-color: black;
      box-shadow: none;
    }
`;

export const AppSelectButtonWrapper = styled.button`
  border: 1px solid ${colors.lightGrey3};
  border-radius: 6px;
  background-color: white;
  font-style: normal;
  font-size: 16px;
  padding: 18px 18px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.darkGrey1};
  font-weight: 600;
  cursor: pointer;

  .icon-text {
    display: flex;
    align-items: center;
    gap: 19px;
  }

  svg {
    fill: ${colors.primary};
  }

  &:active {
    background-color: ${colors.lightGrey1};
  }
`;
